import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state from './state'

/**
 * Use store and sessionStorage to maintain state
 */
export default new Vuex.Store({
  // Force store into strict mode in production.
  // Any mutations to state outside of handlers throws error
  strict: true, //process.env.NODE_ENV !== 'production',
  state,
  getters,
  actions,
  mutations
})
